export default {
  tabs: {
    home: 'Home',
    menu: 'Menu',
    orders: 'Bestellingen',
  },
};
